import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export const useSignOut = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      navigate('/');
    }
  };

  return { handleSignOut };
};
